<template>
	<TripFormSection
		:title="$t('web.edit.trip.name.title')"
		:is-complete="Boolean(inputValue)"
		icon="tag"
	>
		<InputText
			v-model="inputValue"
			solo
			rounded
			:placeholder="$t('web.edit.trip.name.placeholder')"
			:error="error"
			@input="emit('input', $event)"
		/>
	</TripFormSection>
</template>

<script setup lang="ts">
	const inputValue = defineModel<string | number>()

	interface Props {
		error?: string
	}

	defineProps<Props>()

	const emit = defineEmits(['input'])
</script>

<style scoped></style>
